<div class="image-dialog" fxLayout="column">
  <div mat-dialog-content class="content">
    <img [src]="url">
  </div>
  <div mat-dialog-actions fxLayoutAlign="end end">
    <button mat-raised-button mat-dialog-close color="accent">{{ 'close' | translate }}</button>
  </div>
</div>